module.exports = __webpack_public_path__ + "static/media/FES_idiomas_white.d8031cfe.png";